import React, { forwardRef, useEffect, useState } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './InputFileUpload.module.scss'
import UploadIcon from './upload.svg'
import CloseIcon from './close.svg'

import { useFormControl } from '../FormControl'
import Input from '../Input'

const random = () => new Date().getTime()

const InputFileUpload = forwardRef((props, ref) => {
  const { isInvalid } = useFormControl()

  const [inputKey, setInputKey] = useState(random())
  const [selectedFileName, setSelectedFileName] = useState('')
  const { placeholder, value, onChange, onRemove, disabled, ...rest } = props

  const hasSelection = Boolean(selectedFileName)

  const handleChange = (e) => {
    const fileNames = [...e.target.files].reduce((acc, file) => {
      if (acc.length) {
        acc += ', '
      }

      return acc + file.name
    }, '')

    setSelectedFileName(fileNames)
    onChange(e)
  }

  const reset = () => {
    setSelectedFileName('')
    setInputKey(random())
  }

  const handleRemoveClick = (e) => {
    reset()
    onRemove()
  }

  useEffect(() => {
    if (value === null && selectedFileName) {
      reset()
    }
  }, [value, selectedFileName])

  return (
    <div
      className={cx(styles.Group, {
        [styles.FileSelected]: hasSelection,
        [styles.Invalid]: isInvalid,
        [styles.Disabled]: disabled
      })}
    >
      <input key={inputKey} type='file' className={styles.FileInput} {...rest} onChange={handleChange} ref={ref} />
      <Input className={styles.Control} placeholder={placeholder} readOnly value={selectedFileName} />
      <div className={styles.Item}>
        {!hasSelection && (
          <span>
            <UploadIcon width='20px' height='20px' />
          </span>
        )}
        {hasSelection && (
          <span onClick={handleRemoveClick}>
            <CloseIcon width='20px' height='20px' />
          </span>
        )}
      </div>
    </div>
  )
})

InputFileUpload.displayName = 'InputFileUpload'

InputFileUpload.propTypes = {
  /** Invoked when file selection is made */
  onChange: PropTypes.func.isRequired,
  /** Invoked when file selection is made */
  onRemove: PropTypes.func.isRequired
}

InputFileUpload.defaultProps = {
  placeholder: '',
  file: undefined,
  onChange: undefined,
  onRemove: undefined
}

export default InputFileUpload
